import {isAndroid, isIOS, isMacOs, isWindows, isWinPhone} from "react-device-detect";
import EnumOperationSystem from "../enums/EnumOperationSystem";

export default function GetOperationSystem() {

    if (isWindows || isWinPhone) {
        return EnumOperationSystem.Windows;
    } else if (isIOS) {
        return EnumOperationSystem.iOs;
    } else if (isAndroid) {
        return EnumOperationSystem.Android;
    } else if (isMacOs) {
        return EnumOperationSystem.macOS;
    } else {
        return EnumOperationSystem.Linux;
    }

};
